export default {
  getUnlimitedPackageDiscount (packageType, numDates) {
    let result = null
    for (let key in packageType.package_type_discounts) {
      const packageTypeDiscount = packageType.package_type_discounts[key]
      if (numDates >= packageTypeDiscount.booking_qty) {
        result = packageTypeDiscount
      }
    }
    return result
  },
  getUnlimitedPackage (packageTypes) {
    for (let key in packageTypes) {
      const packageType = packageTypes[key]
      if (packageType.category === 'unlimited') {
        return packageType
      }
    }
  },
  getPackageType (packageTypes, packageTypeId) {
    for (let key in packageTypes) {
      const packageType = packageTypes[key]
      if (packageType.id === packageTypeId) {
        return packageType
      }
    }
  },
  getPackageTypeDiscount (packageType, packageTypeDiscountId) {
    for (let key in packageType.package_type_discounts) {
      const packageTypeDiscount = packageType.package_type_discounts[key]
      if (packageTypeDiscount.id === packageTypeDiscountId) {
        return packageTypeDiscount
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/packageHelpers.js